export default "__VITE_ASSET__BKTXPCrj__"